module.exports = __webpack_public_path__ + "img/event_winner_06252.ea758dca.png";